export default ({
  locale, side, quantity, pair, orderType,
}) => {
  const tips = {
    title: '',
    text: '',
  };
  switch (orderType) {
    case 'limit':
      if (side === 'BUY') {
        tips.title = locale === 'cn' ?
          '限价买单已生成'
          : 'Limit Buy Order Created';
        tips.text = locale === 'cn' ?
          `您用${pair[1]}买入${quantity}个${pair[0]}的限价订单已经生成`
          : `Submitted exchange limit buy order for ${quantity} ${pair[0]} by using ${pair[1]}`;
      } else {
        tips.title = locale === 'cn' ?
          '限价卖出单已生成'
          : 'Limit Sell Order Created';
        tips.text = locale === 'cn' ?
          `您卖出${quantity}个${pair[0]}的限价订单已经生成`
          : `Submitted exchange limit sell order for ${quantity} ${pair[0]} by using ${pair[1]}`;
      }
      break;
    case 'market':
      if (side === 'BUY') {
        tips.title = locale === 'cn' ?
          '市价买单已生成'
          : 'Market Buy Order Created';
        tips.text = locale === 'cn' ?
          `您用${pair[1]}买入${quantity}个${pair[0]}的市价订单已经生成`
          : `Submitted exchange market buy order for
            ${quantity} ${pair[0]} by using ${pair[1]}`;
      } else {
        tips.title = locale === 'cn' ?
          '市价卖单已生成'
          : 'Market Sell Order Created';
        tips.text = locale === 'cn' ?
          `您卖出${quantity}个${pair[0]}的市价订单已经生成`
          : `Submitted exchange market sell order for
            ${quantity} ${pair[0]} by using ${pair[1]}`;
      }
      break;
    case 'stop-limit':
      if (side === 'BUY') {
        tips.title = locale === 'cn' ?
          '止盈止损买单已生成'
          : 'Stop Limit Buy Order Created';
        tips.text = locale === 'cn' ?
          `您用${pair[1]}买入${quantity}个${pair[0]}的止盈止损订单已经生成`
          : `Submitted exchange stop limit buy order for
            ${quantity} ${pair[0]} by using ${pair[1]}`;
      } else {
        tips.title = locale === 'cn' ?
          '止盈止损卖单已生成'
          : 'Market Sell Order Created';
        tips.text = locale === 'cn' ?
          `您卖出${quantity}个${pair[0]}的止盈止损订单已经生成`
          : `Submitted exchange stop limit sell order for
            ${quantity} ${pair[0]} by using ${pair[1]}`;
      }
      break;
    case 'oco':
      if (side === 'BUY') {
        tips.title = locale === 'cn' ?
          'OCO买单已生成'
          : 'OCO Buy Order Created';
        tips.text = locale === 'cn' ?
          `您用${pair[1]}买入${quantity}个${pair[0]}的OCO订单已经生成`
          : `Submitted exchange OCO buy order for
            ${quantity} ${pair[0]} by using ${pair[1]}`;
      } else {
        tips.title = locale === 'cn' ?
          'OCO卖单已生成'
          : 'OCO Sell Order Created';
        tips.text = locale === 'cn' ?
          `您卖出${quantity}个${pair[0]}的OCO订单已经生成`
          : `Submitted exchange OCO sell order for
            ${quantity} ${pair[0]} by using ${pair[1]}`;
      }
      break;
    default:
      throw new Error(`Unknown or unsupported order type ${orderType}`);
  }
  return tips;
};
